export function assertUnexpectedValue(name: string, unexpectedValue: never): never {
  throw new Error(`Unexpected value for ${name} : ${unexpectedValue}`);
}

export function assertUnreachable(message: string, value: never): never {
  throw { message, value };
}
